import { render } from "./UserRoutes.vue?vue&type=template&id=53c18619&scoped=true"
import script from "./UserRoutes.vue?vue&type=script&lang=ts"
export * from "./UserRoutes.vue?vue&type=script&lang=ts"

import "./UserRoutes.vue?vue&type=style&index=0&id=53c18619&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-53c18619"

export default script